module.exports = __webpack_public_path__ + "static/assets/4ea7c61d2cbfd28b75d7e188f1815d80.gif";